const domain = process.env.NODE_ENV === 'production' ? 'https://ucenter.diditaxi.com.cn'
  : process.env.NODE_ENV === 'qatest' ? 'http://10.78.128.88:8000' : 'https://ucenterpre.diditaxi.com.cn'
// const domain = process.env.NODE_ENV === 'production' ? 'https://ucenter.diditaxi.com.cn' : 'http://10.190.13.92:3101'
// const domain = 'https://ucenterpre.diditaxi.com.cn'
// const domain = 'http://10.190.13.92:3100'
const renamePageDomain = process.env.NODE_ENV === 'production' ? '//page.udache.com/middle-platform-pages' : 'http://10.179.117.46/middle-platform'
const faqPageDomain = '//dpubstatic.udache.com/static/dpubimg'
const NameIdentityDomain = process.env.NODE_ENV === 'production' ? '//page.udache.com/middle-platform/name-identity/1.1.0/index.html' : 'http://real-name-test.intra.xiaojukeji.com/name-identity/index.html'

let urlObj = {
  getCode: `${domain}/ucenter/v1/sendSmsCode`,
  checkCode: `${domain}/ucenter/v1/verifySmsCode`,
  getImgCode: `${domain}/ucenter/v1/getCaptcha`,
  checkImgCode: `${domain}/ucenter/v1/verifyCaptcha`,
  getRealNameInfo: `${domain}/ucenter/v1/getRealNameInfo`,
  verifyRn: `${domain}/ucenter/v1/verifyRn`,
  ocrIdno: `${domain}/ucenter/v1/ocrIdnoFront`,
  unbind: `${domain}/ucenter/v1/unbind`,
  getSessionId: `${domain}/ucenter/v1/getSessionId`,
  confirmRealName: `${domain}/ucenter/v1/confirmRealName`,
  renamePage: `${renamePageDomain}/rename-appeal/index.html#/`,
  clearNamePage: `${renamePageDomain}/rename-clear/index.html#/`,
  bankList: `${faqPageDomain}/8f281ac5b747d9937a61272bcc92b1e2/index.html`,
  sendSmsCodeWithCell: `${domain}/ucenter/v1/sendSmsCodeWithCell`,
  captchaWithCell: `${domain}/ucenter/v1/getCaptchaWithCell`,
  verifyCaptchaWithCell: `${domain}/ucenter/v1/verifyCaptchaWithCell`,
  bankNameQuery: `${domain}/ucenter/v1/renameAppeal/getBankName`,
  getAuthState: `${domain}/ucenter/v1/getAuthState`,
  getUserInfo: `${domain}/ucenter/v1/getUserInfo`,
  goNameIdentityPage: `${NameIdentityDomain}`
}

export {
  urlObj
}
